import axios from 'axios'

const API_URL = process.env.VUE_APP_AI_AGENT_API_BASE_URL || 'https://localhost:5001/api/'

class WorkflowService {
  // Get all workflows for a project
  getWorkflowsByProject (projectId) {
    return axios.get(API_URL + 'projects/' + projectId + '/workflows')
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching workflows:', error)
        throw error
      })
  }

  // Get specific workflow
  getWorkflowById (projectId, workflowId) {
    return axios.get(API_URL + 'projects/' + projectId + '/workflows/' + workflowId)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching workflow:', error)
        throw error
      })
  }

  // Create new workflow
  createWorkflow (projectId, workflowData) {
    return axios.post(API_URL + 'projects/' + projectId + '/workflows', workflowData)
      .then(response => response.data)
      .catch(error => {
        console.error('Error creating workflow:', error)
        throw error
      })
  }

  // Update workflow
  updateWorkflow (projectId, workflowId, workflowData) {
    return axios.put(API_URL + 'projects/' + projectId + '/workflows/' + workflowId, workflowData)
      .then(response => response.data)
      .catch(error => {
        console.error('Error updating workflow:', error)
        throw error
      })
  }

  // Delete workflow
  deleteWorkflow (projectId, workflowId) {
    return axios.delete(API_URL + 'projects/' + projectId + '/workflows/' + workflowId)
      .then(response => response.data)
      .catch(error => {
        console.error('Error deleting workflow:', error)
        throw error
      })
  }

  // Duplicate workflow
  duplicateWorkflow (projectId, workflowId) {
    return axios.post(API_URL + 'projects/' + projectId + '/workflows/' + workflowId + '/duplicate')
      .then(response => response.data)
      .catch(error => {
        console.error('Error duplicating workflow:', error)
        throw error
      })
  }

  // Execute workflow
  executeWorkflow (projectId, workflowId, executionData) {
    return axios.post(API_URL + 'projects/' + projectId + '/workflows/' + workflowId + '/execute', executionData)
      .then(response => response.data)
      .catch(error => {
        console.error('Error executing workflow:', error)
        throw error
      })
  }

  // Get workflow execution history
  getWorkflowExecutions (projectId, workflowId) {
    return axios.get(API_URL + 'projects/' + projectId + '/workflows/' + workflowId + '/executions')
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching workflow executions:', error)
        throw error
      })
  }

  // Get specific execution
  getExecutionById (projectId, workflowId, executionId) {
    return axios.get(API_URL + 'projects/' + projectId + '/workflows/' + workflowId + '/executions/' + executionId)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching execution:', error)
        throw error
      })
  }

  // Cancel execution
  cancelExecution (projectId, workflowId, executionId) {
    return axios.post(API_URL + 'projects/' + projectId + '/workflows/' + workflowId + '/executions/' + executionId + '/cancel')
      .then(response => response.data)
      .catch(error => {
        console.error('Error cancelling execution:', error)
        throw error
      })
  }
}

export default new WorkflowService()
